export default [
  {
    path: '/video-egitim',
    name: 'video-egitim',
    component: () => import('./Index.vue'),
    meta: {
      public: false,
      title: "video_egitim.Video_Egitim",
      yetki: { k: [1360002] },
    },
  },
]
